(function($) {
  function newhomepageSlick(){
    $('.ri-txt-slide-slick').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      dots: false,
      draggable: false,
      asNavFor: '.ri-img-slide-slick',
      responsive: [
        {
          breakpoint: 992,
          settings: {
            dots: true
          }
        }
      ]
    });
    $('.ri-img-slide-slick').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      dots: true,
      fade: true,
      lazyLoad: 'ondemand',
      asNavFor: '.ri-txt-slide-slick',
      responsive: [
        {
          breakpoint: 992,
          settings: {
            dots: false
          }
        }
      ]
    });
  }

  function paddingSlideText(){
    var containerWidth = $('.header .container').width(),
        windoWidth = $(window).width(),
        leftPadding = windoWidth - containerWidth,
        tagetSection = $('.ris-text-content');
        tagetSection.each(function(){
          if($(this).hasClass("right-side")){
            $(this).css('padding-right', leftPadding/2);
          }else {
            $(this).css('padding-left', leftPadding/2);
          }
        });
        
    
  }
  $(window).resize(paddingSlideText);


  function benefitsListSlick(){
    if($(window).width() < 768 ){
      $('.benefits-list-slick').each(function(){
        $('.benefits-list-slick').slick({
          infinite: false,
          slidesToShow: 1,
          slidesToScroll: 1,
          prevArrow: '<div class="benefits-slick-arrow ben-slick-prev fa fa-angle-left">',
          nextArrow: '<div class="benefits-slick-arrow ben-slick-next fa fa-angle-right">',
          dots: true,
        });
        
      });
      $('.prod-features.grid').each(function(){
        $(this).slick({
          infinite: false,
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
          dots: true,
        });
      });
      $('.section-testimonials .testimonials.grid').slick({
        infinite: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: true,
      });
    }else{
      $('.benefits-list-slick').each(function(){
        $('.benefits-list-slick').slick('unslick');
      });
    }
  }
  $(window).resize(benefitsListSlick);


  var totalElementHeight = 0;
  var elementVdistance = 0;
  var contentWrapHeight = 0;
  function faqNavSticky(){
    totalElementHeight = $(".faq-page-nav").outerHeight(true) - 46;
    elementVdistance = $(".faq-page-nav").offset().top - totalElementHeight;
    contentWrapHeight = $(".faq-content-wrapper").outerHeight(true) - (totalElementHeight * 2);
  }
  $(document).ready(function() {
    if($('.productpage-capabilities-section').length > 0 ){
      $('#shopify-section-prod-feature-capabilities').prependTo('.productpage-capabilities-section');
    }
    newhomepageSlick();
    paddingSlideText();
    benefitsListSlick();
    if ($(".faq-page-nav").length > 0 ){
      faqNavSticky();
			$(window).resize(function() {
				totalElementHeight = $(".faq-page-nav").outerHeight(true) - 46;
				elementVdistance = $(".faq-page-nav").offset().top - totalElementHeight;
				contentWrapHeight = $(".faq-content-wrapper").outerHeight(true) - (totalElementHeight * 2);
			});
			$(document).on("scroll", function(){
				if($(document).scrollTop() > elementVdistance && $(window).width() > 560 ){
						$(".faq-page-nav").addClass("sticky");
						if($(document).scrollTop() > contentWrapHeight + elementVdistance){
							$(".faq-page-nav").addClass("stop");
							$(".faq-page-nav").css("top", contentWrapHeight + elementVdistance + totalElementHeight);
						}else{
							$(".faq-page-nav").removeClass("stop");
							$(".faq-page-nav").css("top", '100px');
						}
				}
				else
				{
					$(".faq-page-nav").removeClass("sticky");
				}
			});
    }
    
  });
})(jQuery);

/*  REORDER FUNCTIONALITY */
this.reorder = new function(){
  var self = this;

  this.pushQueue = function(i, data, el){
    
    //LOW STOCK -- add as many as possible if stock is below requested ammount
    if(data[i].check_inventory){
      data[i].quantity = Math.min(parseInt(data[i].inventory), parseInt(data[i].quantity));
    }
    
    $.ajax({
      url: '/cart/add.js',
      method: 'POST',
      data: {
        quantity: data[i].quantity,
        id: data[i].id
      },
      complete: function(res){
        if(i >= data.length - 1){
          //products from queue are now added to the cart -> stop loading signal and go to cart
          el.removeClass('loading');
          window.location.href = '/cart';
          return;
        }else{
          // Calls are async as required by Shopify Docs
       	  self.pushQueue(i+1, data, el);
        }
      }
    });
  }

  this.listen = function(){
    var el = $(this);
    var ids = el.attr('data-variant-ids').split(',');
    var quantities = el.attr('data-variant-quantities').split(',');
    var inventories = el.attr('data-variant-inventories').split(',');
    var inventory_policies = el.attr('data-variant-inventory-policies').split(',');
    var inventory_trackers = el.attr('data-variant-inventory-trackers').split(',');
    ids.splice(-1, 1);
    quantities.splice(-1, 1);
    inventories.splice(-1, 1);
    inventory_policies.splice(-1, 1);
    inventory_trackers.splice(-1, 1);
    
    var data = [];
    for(var i=0; i<ids.length; i++){
      data.push({
        id: ids[i],
        quantity: quantities[i],
        inventory: inventories[i],
        check_inventory: (inventory_policies[i] == "deny" && inventory_trackers[i] != "")
      });
    }
    el.addClass('loading');
    self.pushQueue(0, data, el);
  }
  
  this.init = function(){
    $('.reorder-btn').on('click', self.listen);
  }
}
$(reorder.init);
